<template>
    <ul class="offer-item-categories-list" v-if="offer.hasItemCategories" :class="{ 'custom-color': useCustomColor }">
        <li
            v-for="category in offer.itemCategories"
            :key="category.categoryId"
            :class="{ active: isActiveCategory(category) }"
            @click="setAsActiveCategory(category)"
        >
            {{ translateByLocationLanguage(category.name) }}
        </li>
    </ul>
</template>

<script setup lang="ts">
    import type { ICustomerCategory } from "@/data/model/Customer";
    import { useOfferStore } from "@/data/stores/offer";
    import { translateByLocationLanguage } from "@/shared/localization/language";

    const offer = useOfferStore();
    defineProps<{
        useCustomColor?: boolean;
    }>();

    const emit = defineEmits(["categorySelected"]);

    function isActiveCategory(category: ICustomerCategory) {
        return offer.activeCategory === category;
    }

    function setAsActiveCategory(category: ICustomerCategory) {
        offer.setActiveCategory(category);
        emit("categorySelected", category);
    }
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";
    @use "./../../../assets/styles/scss/shared/_mixins.scss";

    ul.offer-item-categories-list {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            font-size: 1.2em;
            font-weight: 500;
            padding: 1.25em 0.9em;
            color: colors.$fontColor;
            word-break: break-word;

            border-bottom: 1px solid #ccc;
            cursor: pointer;

            transition: background-color 0.15s linear;

            @include mixins.hover-and-active() {
                background-color: #ddd;
            }

            &.active {
                background-color: #777;
                color: white;
            }
        }

        &.custom-color {
            li {
                @include mixins.hover-and-active() {
                    background-color: var(--colorPrimaryHover);
                    color: white;
                }

                &.active {
                    background-color: var(--colorPrimary);
                    color: white;
                }
            }
        }
    }
</style>
